import { memo } from 'react';
import PropTypes from 'prop-types';
import TourItineraryContent from './TourItineraryContent';

const TourItinerary = ({
  itinerary, tripId,
  onMouseEnter, onMouseLeave, doScrollToTour, doHaveBorderAround, wrapperClassName, doShowPrice,
}) => (
  <TourItineraryContent
    itinerary={itinerary}
    tripId={tripId}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    doScrollToTour={doScrollToTour}
    doHaveBorderAround={doHaveBorderAround}
    wrapperClassName={wrapperClassName}
    doShowPrice={doShowPrice}
  />
);

TourItinerary.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  doScrollToTour: PropTypes.bool,
  doHaveBorderAround: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  doShowPrice: PropTypes.bool,
};

TourItinerary.defaultProps = {
  tripId: '',
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  doScrollToTour: true,
  doHaveBorderAround: true,
  wrapperClassName: 'rounded-lg',
  doShowPrice: true,
};
export default memo(TourItinerary);
